import React from "react";
import "./Pools.css";
import { useInView } from "react-intersection-observer";

import image1 from "../../images/morepics/401 Bunker Hill - The View_001.jpg";
import image2 from "../../images/morepools/MICO Pool Design - IBP_002.jpg";
import ImageAccordion from "../../components/ImageAccordion/ImageAccordion";
import SEO from "../../components/SEO";

export default function Pools() {
    const { ref: introRef, inView: introVisible } = useInView();
    const { ref: featureRef, inView: featureVisible } = useInView();

    return (
        <>
            <SEO
                title="Custom Pool Designs | MICO Pool Design and Consulting"
                description="Explore custom pool design services from MICO, including 3D backyard concepts, spas, tanning ledges, lighting, and outdoor living features."
            />
            <div className="pools">
                <h1 className="pools-header">POOLS</h1>
            </div>

            <section className="pools-content">
                <div
                    className={
                        introVisible ? "pools-left pools-left-move" : "pools-left"
                    }
                    ref={introRef}
                >
                    <h2>Give Your House a Make Over</h2>
                    <p>
                        At Mico Pool Designs and Consulting, our mission is to
                        create exceptional pool designs that bring your vision
                        to life.
                        <br />
                        <br />
                        We believe that a well-designed pool is more than just a
                        water feature; it&apos;s a sanctuary, a gathering place, and
                        a statement of style. Let us help you create the pool of
                        your dreams and transform your backyard into a haven of
                        relaxation and enjoyment.
                    </p>
                </div>
                <div className="pools-right-image-wrap">
                    <img
                        className="pools-image"
                        src={image1}
                        alt="Custom pool design rendering"
                    />
                </div>
            </section>

            <section className="pool-designs">
                <h2>Our Pool Designs</h2>
                <p>
                    At Mico Pool Designs and Consulting, we specialize in
                    creating bespoke pool designs that reflect your unique style
                    and preferences. Our portfolio includes:
                </p>
            </section>

            <ImageAccordion />

            <section className="pools-content pools-content-reverse">
                <div className="pools-left-image-wrap">
                    <img
                        className="pools-image"
                        src={image2}
                        alt="Luxury backyard pool concept with custom features"
                    />
                </div>
                <div
                    className={
                        featureVisible
                            ? "pools-right pools-right-move"
                            : "pools-right"
                    }
                    ref={featureRef}
                >
                    <h2>Features and Customizations</h2>
                    <p>
                        Every pool concept is tailored to the way you want to
                        live outdoors. We think through layout, circulation,
                        waterline placement, and surrounding features so the
                        final design feels elevated and fully connected to your
                        backyard.
                        <br />
                        <br />
                        From tanning ledges and spas to integrated seating,
                        lighting, and entertaining zones, we build each design
                        around comfort, style, and long-term usability.
                    </p>
                </div>
            </section>
        </>
    );
}
